import styled from"@emotion/styled";import{Form}from"@wp/src/components/common";export const TransactionFormContainer=styled(Form)`
  .ant-form-item {
    margin-bottom: 12px;
    .ant-form-item-label {
      padding-bottom: 4px;
    }
  }
`;